<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    mask: {
      type: [String, Function],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['email', 'number', 'password', 'search', 'tel', 'text', 'url'].includes(value)
      },
    },
    error: {
      type: String,
      default: '',
    },
    textarea: {
      type: Boolean,
    },
    changed: {
      type: Boolean,
    },
    changedColor: {
      type: String,
      default: '#FFEDE1',
    },
    maxlength: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <textarea
      v-if="textarea"
      v-maska="mask"
      :type="type"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      :class="{ [$style.input]: true, [$style.error]: error }"
      v-bind="$attrs"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners" />
    <input
      v-else
      v-maska="mask"
      :style="{ background: changed ? changedColor : '#fff' }"
      :type="type"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      :class="{ [$style.input]: true, [$style.error]: error }"
      v-bind="$attrs"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners" />
    <div :class="$style.errorContainer">
      <p v-if="error" :class="$style.errorMessage" class="tag-text">{{ error }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

textarea.input {
  height: 120px;
  resize: none;
  border-radius: 12px;
}

.input {
  width: 100%;
  height: 40px;
  padding: 10px 10px 10px 24px;
  font-size: 16px;
  color: $primary-blue;
  border: 0.5px $primary-blue solid;
  border-radius: 36px;
  outline: none;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $gray;
    opacity: 1;
  }

  &:disabled {
    opacity: 0.7;
  }

  &.error {
    color: $secondary-red;
    border: 0.5px $secondary-red solid;
  }
}

.errorContainer {
  position: absolute;
  right: 0;
  left: 0;

  .errorMessage {
    @extend %error-message;

    text-align: right;
  }
}
</style>
